import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import GroomingPage from "./pages/GroomingPage";
import ShopPage from "./pages/ShopPage";
import GalleryPage from "./pages/GalleryPage";
import WarningSignsPage from "./pages/WarningSignsPage";
import ContactPage from "./pages/ContactPage";
import WhyUsPage from "./pages/WhyUsPage";
import ReviewsPage from "./pages/ReviewsPage";
import { Toaster } from "./components/ui/sonner";
import { ScrollToTop } from "./components/ScrollToTop";
import OffersPopup from "./components/OffersPopup";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/grooming" element={<GroomingPage />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/warning-signs" element={<WarningSignsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/why-us" element={<WhyUsPage />} />
          <Route path="/reviews" element={<ReviewsPage />} />
        </Routes>
        <OffersPopup />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
